import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Skeleton,
  Stack,
} from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "@helpers/axios/private.axios";

export const CompanySelect = ({ control, required = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    try {
      setLoading(true);
      const resp = await axios.get("/common/companies");

      setData(resp.data.data);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="bo-input">
      <label className="bo-input__label">
        <p className="bo-input__label-text">Company:</p>
        <div className="bo-input__wrap">
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <Controller
                name="company"
                control={control}
                rules={{ required }}
                render={({ field }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    className="bo-select"
                    {...field}
                    variant="standard"
                    MenuProps={{
                      className: "bo-select-content",
                    }}
                  >
                    {loading ? (
                      <Stack spacing="6px">
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width="100%"
                          height={60}
                          className="bo-skeleton"
                        />
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width="100%"
                          height={60}
                          className="bo-skeleton"
                        />
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width="100%"
                          height={60}
                          className="bo-skeleton"
                        />
                      </Stack>
                    ) : (
                      data.map((el) => (
                        <MenuItem key={el} value={el}>
                          {el}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
        </div>
      </label>
    </div>
  );
};

export default CompanySelect;
